import Vue from 'vue'
import {mapState} from 'vuex'
const defaultMergeStrategy = Vue.config.optionMergeStrategies.beforeCreate
Vue.config.optionMergeStrategies.beforeCreate = function mergeHook (parentVal, childVal) {
  if(childVal && childVal.shouldRunFirst) {
    return [childVal].concat(parentVal)
  } else {
    return defaultMergeStrategy(parentVal, childVal)
  }
}
function _beforeCreateButFirst () {
  // por si ha habido un refresh de development, y ya se habia hecho
  if(this.$options._indDataDefs) return
  
  this.$options._indDataDefs = this.$options.computed.indicatorData()
  
  if(!this.$options.asyncComputed) this.$options.asyncComputed = {}

  Object.keys(this.$options._indDataDefs).forEach((key)=>{
    
    
    // hay que hacer algo asi!!!!, para tener unos "async_computed" de verdad,
    //y luego unos wrapper (Si hace falta????) para el latestData
    
    
    // this.$options.asyncComputed['actual_asc_' + key] = {
    //   get: this.$options._indDataDefs[key].get
    // }
    
    // this.$options.asyncComputed['asc_' + key] = {
    //   get: ()=>{
    //     if(this.visible && this.pendingFetch) {
    //       return this['actual_asc_'+key]
    //     }
    //     else return null
    //   } 
    // }
    this.$options.asyncComputed['asc_' + key] = {
      get: ()=>{
        if(this.visible && this.pendingFetch[key]) {
          return this.$options._indDataDefs[key].get.call(this).then((res) => {
            this.latestData[key] = res
            this.pendingFetch[key] = false
            return Date.now()
          }).catch((res)=>{
            this.latestData[key] = null
            this.pendingFetch[key] = false
            return Date.now()
          })
        }
        else{
          return Date.now()
        }
      } 
    }
  })

  this.$options.computed.indicatorData = () => {
    let res = {}
    Object.keys(this.$options._indDataDefs).forEach((key)=>{
      res[key] = this.latestData[key]
    })
    // res['test'] = this['asc_'+'test']
    return res
  }
}
_beforeCreateButFirst.shouldRunFirst = true

export default {
  data () {
    let latestData = {}
    let pendingFetch = {}
    Object.keys(this.$options._indDataDefs).forEach((key)=>latestData[key]=null)
    Object.keys(this.$options._indDataDefs).forEach((key)=>pendingFetch[key]=true)
    return {
      pendingFetch,
      latestData
    }
  },
  props: ['indicator', 'visible'],
  
  beforeCreate: _beforeCreateButFirst,

  methods: {
  },
  computed: {
    isFetching () {
      let defs = this.$options._indDataDefs
      let res = Object.keys(defs).filter((key)=>defs[key].required).reduce((val,key)=>{
        // return val || this['asc_'+key] === null
        return this.pendingFetch[key] || this.$asyncComputed['asc_'+key].updating
      },false)
      return res
    },
    isFetchingCompare () {
      return this.pendingFetch['compare_data'] || this.$asyncComputed['asc_compare_data'].updating
    },
    hasData () {
      let defs = this.$options._indDataDefs
      
      // "SOLO" sirve para el ind_trust (aka recovery) que tiene triggers_jump = true
      // pero hay que hacerlo "internamente" con una cadena de "thens"??? ????

      // let trigger = Object.keys(defs).filter((key)=>defs[key].required).reduce((val,key)=>{
      //   return val && this.latestData[key]===null && defs[key].triggers_jump
      // },true)
      // if(trigger){
      //   console.log("-----> SHOULD TRIGGER NODE JUMP")
      //   // CUANDO VENGA EL parent hacemos esto...
      //   // let parent = {glk: this.$store.state.nodeInfo.parent_glk, id: this.$store.state.nodeInfo.parent_id}
        
      //   // let parent = {glk: 'COUNTRY', id: -1311341}
      //   // this.$router.push({ path: `/${parent.glk}/${parent.id}` })
      // }

      let res = Object.keys(defs).filter((key)=>defs[key].required).reduce((val,key)=>{
        return val && this.latestData[key]!==null
      },true)
      return res
    },
    /*compareNodeInfo () {
      let node = {}
      if (this.isCompareMode) {
        node = {
          id: this.$route.query.compare_node_id,
          glk: this.$route.query.compare_node_glk
        }
      }
      return node
    },*/
    isCompareMode () {
      return this.$route.query.compare_node_id && this.$route.query.compare_node_glk
    },
    hasDataCompare () {
      return this.$options._indDataDefs['compare_data'] && this.latestData['compare_data']!==null
    },
    legendItems () {
      let leg = [
        {
          'label': this.nodeInfo.value
        },
        {
          'label': this.compareNodeInfo ? this.compareNodeInfo.value : '',
          'class': 'compare'
        }
      ]
      if(this.isFetching) {
        leg[0].label += ' (Calculando)'
      } else if (!this.hasData) {
        leg[0].label += ' (No hay datos)'
      }

      if(this.isFetchingCompare) {
        leg[1].label += ' (Calculando)'
      } else if (!this.hasDataCompare) {
        leg[1].label += ' (No hay datos)'
      }


      return leg
    },
    status () {
      if(this.isFetching) return {status:'fetching'}
      else if (this.hasData) return {status:'ready'}
      else return {status: 'error'}
    },
    ...mapState(['nodeInfo', 'compareNodeInfo'])
  },

  watch:{
    currentFilters () {
      // let defs = this.$options._indDataDefs
      // let self = this
      // Object.keys(defs).forEach((key)=>{
      //   console.log(key,' deps: ',self.$asyncComputed['asc_'+key].__ob__.dep.subs.length)
      // })
      // this.pendingFetch = true
      
      // HABRIA MIRAR/PONER de alguna manera si "realemtne" este filtro requierer refetch!!!!
      
      Object.keys(this.$options._indDataDefs).forEach((key)=>this.pendingFetch[key] = true)
    },
    // $route(to, from) {
    //   if(to.path !== from.path){
    //     Object.keys(this.$options._indDataDefs).forEach((key)=>this.pendingFetch[key] = true)
    //   }
    // }
    nodeInfo(){
      Object.keys(this.$options._indDataDefs).forEach((key)=>this.pendingFetch[key] = true)
    },
    compareNodeInfo(){
      // Only reload indicators with "compare_" key, avoid reloading main node
      Object.keys(this.$options._indDataDefs).filter(el => el.includes('compare')).forEach((key)=>this.pendingFetch[key] = true)
    }
  }
}